import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaCalendarAlt } from '@react-icons/all-files/fa/FaCalendarAlt';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaRegCalendarCheck } from '@react-icons/all-files/fa/FaRegCalendarCheck';
import { FaUmbrellaBeach } from '@react-icons/all-files/fa/FaUmbrellaBeach';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../commons/TileContainer';

import CalendarioWorkflowPage from './calendario-workflow/calendario-workflow-page';
import PeriodosPage           from './periodos/periodos-page';
import FeriadosPage           from './feriados/feriados-page';

const tiles: TileItem[] = [
  { key: 'calendario-workflow', label: 'Calendario Workflow', icon: <FaProjectDiagram />,  color: '#6366f1' },
  { key: 'periodos',            label: 'Periodos',            icon: <FaRegCalendarCheck />, color: '#0ea5e9' },
  { key: 'feriados',            label: 'Feriados',            icon: <FaUmbrellaBeach />,    color: '#f59e0b' },
];

function CalendarioIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',               icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',  icon: <FaCog /> },
        { label: 'Calendario',                           icon: <FaCalendarAlt /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#ef4444' }}>
          <FaCalendarAlt style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Calendario</h2>
          <p style={s.subtitle}>Configuración de calendario</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/calendario/${key}`)}
      />
    </div>
  );
}

export default function CalendarioConfigPage() {
  return (
    <Routes>
      <Route path="/"                    element={<CalendarioIndex />} />
      <Route path="/calendario-workflow/*" element={<CalendarioWorkflowPage />} />
      <Route path="/periodos/*"           element={<PeriodosPage />} />
      <Route path="/feriados/*"           element={<FeriadosPage />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page:    { display: 'flex', flexDirection: 'column', gap: 28 },
  header:  { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:    { fontSize: 22, color: '#fff' },
  title:   { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle:{ margin: 0, fontSize: 13, color: '#64748b' },
};
